import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export default function Pagination({
  currentPage = 1,
  totalCount = 0,
  pageSize = 10,
  onPageChange,
}) {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalPages <= 1) return null;

  const getPages = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 2) {
      return [1, 2, 3];
    }
    if (currentPage >= totalPages - 1) {
      return [totalPages - 2, totalPages - 1, totalPages];
    }
    return [currentPage - 1, currentPage, currentPage + 1];
  };

  const pages = getPages();

  return (
    <div className="flex items-center gap-2">
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="h-9 w-9 flex items-center justify-center rounded-lg border border-slate-200 text-gray-900 bg-white hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed">
        <FiChevronLeft size={16} />
      </button>

      {pages[0] !== 1 && (
        <>
          <button onClick={() => onPageChange(1)} className="h-9 w-9 bg-white flex items-center justify-center rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50">1</button>
          {pages[0] > 2 && (
            <span className="px-1 text-slate-400">...</span>
          )}
        </>
      )}

      {pages.map((page) => (
        <button key={page} onClick={() => onPageChange(page)} className={`h-9 w-9 flex items-center justify-center rounded-lg text-sm font-semibold transition-colors ${currentPage === page ? "bg-indigo-600 text-white" : "border border-slate-200 text-slate-600 bg-white hover:bg-slate-50"}`}>
          {page}
        </button>
      ))}

      {pages[pages.length - 1] !== totalPages && (
        <>
          {pages[pages.length - 1] < totalPages - 1 && (
            <span className="px-1 text-slate-400">...</span>
          )}

          <button onClick={() => onPageChange(totalPages)} className={`h-9 w-9 flex items-center bg-white justify-center rounded-lg text-sm font-semibold transition-colors ${currentPage === totalPages ? "bg-indigo-600 text-white" : "border border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
            {totalPages}
          </button>
        </>
      )}

      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="h-9 w-9 flex items-center justify-center rounded-lg border border-slate-200 text-slate-500 bg-white hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed">
        <FiChevronRight size={16} />
      </button>
    </div>
  );
}